var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.023 15.5925C15.368 15.9375 15.9005 15.405 15.5555 15.0675L12.743 12.2475C13.7298 11.156 14.2752 9.73643 14.273 8.265C14.273 4.9725 11.5955 2.295 8.30301 2.295C5.01051 2.295 2.33301 4.9725 2.33301 8.265C2.33301 11.5575 5.01051 14.235 8.30301 14.235C9.78801 14.235 11.1605 13.6875 12.2105 12.78L15.023 15.5925ZM3.08226 8.265C3.08226 5.385 5.42976 3.045 8.30226 3.045C11.1823 3.045 13.5223 5.385 13.5223 8.265C13.5223 11.145 11.1823 13.485 8.30226 13.485C5.42976 13.485 3.08226 11.145 3.08226 8.265Z",
    fill: "#848080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b51d5e5cc452bcf54edf32c87a732f9f.svg";
export { ForwardRef as ReactComponent };